export default "__VITE_ASSET__dbl67iNT__"